import { useState } from "react";
import Table from "../../components/Table/index.jsx";
import { Link, useLocation } from "react-router-dom";

// Icons
import { FiRefreshCcw } from "react-icons/fi";
import { FaRegEye } from "react-icons/fa";

const FetchAWBNumbersBYfranchise = () => {
    const location = useLocation();
    const deliveryPartnerId = location?.state?.deliveryPartnerId || null;
    const isDeliveryPartner = location?.state?.isDeliveryPartner || false;
    const [showModal, setShowModal] = useState(false);
    const [modalImage, setModalImage] = useState("");

    const handleOpenModal = (imageUrl) => {
        setModalImage(imageUrl);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalImage("");
    };


    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [formData, setFormData] = useState({
        fromDate: "",
        toDate: "",
        awbNo: "",
        SenderName: "",
        type: "all",
    });

    const handleChange = (e) => {
        const { name, value } = e?.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleReset = () => {
        setFormData({
            fromDate: "",
            toDate: "",
            awbNo: "",
            SenderName: "",
            type: "all",
        });
    };

    const orderTableColumns = [
        {
            name: "No", // Serial / Count Column
            selector: (row, index) => (
                <span className="text-xs text-gray-700">{index + 1}</span>
            ),
            width: "50px",
            sortable: false, // Usually serial number column is not sortable
        },
        {
            name: "Received DATE",
            sortable: true,
            selector: () => <span className="text-xs">12-09-2025</span>,
            width: "130px",
        },
        //         {
        //             name: "Customer Name",
        //             sortable: true,
        //             selector: () => "Kishan Patel",
        //             cell: () => (
        //                 <div
        //                     className="truncate max-w-xs cursor-pointer text-xs"
        //                     title={`Name: Kishan Patel
        // To: 112, Ramkrupa Soc, Surat
        // Pincode: 395066
        // Mo: 9876543210`}
        //                 >
        //                     Kishan Patel
        //                 </div>
        //             ),
        //         },
        // {
        //     name: "AWB NO",
        //     sortable: true,
        //     selector: () => "UK123456789",
        //     cell: () => (
        //         <span className="text-xs font-medium text-blue-600 cursor-pointer">
        //             UK123456789
        //         </span>
        //     ),
        //     width: "150px",
        // },
        {
            name: "Franchise Name",
            sortable: true,
            selector: () => "Kishan Patel",
            cell: () => (
                <div
                    className="truncate max-w-xs cursor-pointer text-xs"
                    title={`Name: Kishan Patel
To: 112, Ramkrupa Soc, Surat
Pincode: 395066
Mo: 9876543210`}
                >
                    Kishan Patel
                </div>
            ),
        },
        {
            name: "Franchise ID",
            sortable: true,
            selector: () => "S001",
            cell: () => (
                <span className="text-xs font-medium text-blue-600 cursor-pointer">
                    S001
                </span>
            ),
            width: "150px",
        },


        {
            name: "Received Shipment",
            sortable: true,
            selector: () => "S001",
            cell: () => (
                <span className="text-xs font-medium text-green-600 cursor-pointer">
                    S001
                </span>
            ),
            width: "150px",
        },
        {
            name: "Not Received Shipment",
            sortable: true,
            selector: () => "S001",
            cell: () => (
                <span className="text-xs font-medium text-red-600 cursor-pointer">
                    S001
                </span>
            ),
            width: "150px",
        },
        {
            name: "Total Shipment",
            sortable: true,
            selector: () => "S001",
            cell: () => (
                <span className="text-xs font-medium text-slate-800 cursor-pointer">
                    S001
                </span>
            ),
            width: "150px",
        },
        {
            name: "Submitted?",
            sortable: true,
            selector: () => "NO",
            cell: () => (
                <span
                    className="text-xs font-medium text-red-600 cursor-pointer"
                // onClick={() =>
                //     handleOpenModal("https://via.placeholder.com/300x200.png?text=OTP+Verified+Image")
                // }
                >
                    Parcel Received <span className="text-green-600">(OTP Not Verified)</span>
                    {/* Parcel Not Received <span className="text-green-600">(OTP Verified)</span></span> */}
                </span >
            ),
            width: "150px",
        },
        {
            name: "Received Partner",
            sortable: true,
            selector: () => "Ramesh Sharma",
            cell: () => (
                <div className="flex flex-col">
                    <span className="text-xs text-slate-400">
                        Pickup by{" "}
                        <span className="font-semibold text-gray-700">Ramesh Sharma</span>
                    </span>
                    <p className="text-xs text-slate-400">
                        ID: <span className="font-semibold text-gray-700">P001</span>
                    </p>
                </div>
            ),
            width: "180px",
        },
        {
            name: "Details",
            sortable: true,
            // selector: () => "RTO Shipment (Otherwise New Shipment)",
            cell: () => (
                <div className="flex items-center gap-2">
                    {/* <span className="text-xs text-red-600">
                        RTO Shipment (Otherwise New Shipment)
                    </span> */}
                    <Link to="/#"> <button
                        // onClick={() => alert("Open shipment details modal here")}
                        className="px-2 py-1 text-xs bg-orange-600 text-white rounded-md hover:bg-orange-700 transition"
                    >
                        View Details
                    </button></Link>
                </div>
            ),
            width: "120px",
        }

    ];

    const handlePagination = (page) => {
        setPage(page?.selected);
    };

    return (
        <div className="w-full px-4 pt-6 pb-10 border border-gray-200 md:rounded-md bg-white">
            {/* Heading */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                <p className="text-lg font-bold text-slate-800">Weight Mismatch BY Franchise</p>
                <button
                    onClick={() => window.location.reload()}
                    className="flex items-center justify-center gap-2 w-full sm:w-auto px-4 h-7 bg-slate-700 hover:bg-slate-800 text-white text-sm font-semibold rounded-md transition"
                >
                    <FiRefreshCcw className="text-base" />
                    Refresh
                </button>
            </div>

            {/* Form */}
            <div className="grid grid-cols-1 md:grid-cols-4 mb-8 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Customer Name:
                    </label>
                    <input
                        type="text"
                        name="SenderName"
                        value={formData.SenderName}
                        onChange={handleChange}
                        placeholder="Enter Sender name"
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Franchise Name:
                    </label>
                    <input
                        type="text"
                        name="SenderName"
                        value={formData.SenderName}
                        onChange={handleChange}
                        placeholder="Enter Sender name"
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Franchise ID:
                    </label>
                    <input
                        type="text"
                        name="awbNo"
                        value={formData.awbNo}
                        onChange={handleChange}
                        placeholder="Enter AWB number(s)"
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>
                {/* AWB No(s) */} <div> <label className="block text-sm font-medium text-gray-700 mb-1">AWB NO(s):</label> <input type="text" name="awbNo" value={formData.awbNo} onChange={handleChange} placeholder="Enter AWB number(s)" className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none" /> </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        From Date:
                    </label>
                    <input
                        type="date"
                        name="fromDate"
                        value={formData.fromDate}
                        onChange={handleChange}
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        To Date:
                    </label>
                    <input
                        type="date"
                        name="toDate"
                        value={formData.toDate}
                        onChange={handleChange}
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                {/* <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        OTP Type:
                    </label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        className="w-full h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    >
                        <option value="all">All</option>
                        <option value="booked">Booked Shipment</option>
                        <option value="received">Received Shipment</option>
                        <option value="sorting">Sorting Shipment</option>
                        <option value="in_transit">In Transit Shipment</option>
                        <option value="received_in_transit">Received In-Transit</option>
                    </select>
                </div> */}

                <div className="md:mt-6 mt-3">
                    <button
                        type="button"
                        onClick={handleReset}
                        className="bg-blue-50 text-black hover:bg-blue-100 text-sm font-medium px-5 py-2 rounded-md"
                    >
                        Reset Form
                    </button>
                </div>
            </div>
            {/* <Link
                to="/scanhub"
                className="inline-block bg-orange-600 hover:bg-orange-700 focus:ring-2 focus:ring-orange-400 focus:outline-none text-white font-semibold rounded-md px-5 py-2 transition-colors duration-200 shadow-md mb-3"
            >
                Scan To Sorting
            </Link> */}
            {/* Table */}
            <div className="text-gray-600 grid grid-cols-1">
                {/* <Table
                    columns={orderTableColumns}
                    data={[{}, {}, {}, {}]} 
                    totalRecords={4}
                    currentPage={page}
                    limit={limit}
                    setLimit={setLimit}
                    setPage={setPage}
                    loading={false}
                    handlePagination={handlePagination}
                /> */}
                <Table
                    columns={orderTableColumns}
                    data={orderTableColumns}
                    currentPage={page}
                    // totalRecords={GetOrderOrder?.getOrders?.count || 0}
                    limit={limit}
                    setLimit={setLimit}
                    setPage={setPage}
                    // loading={false}
                    // deleteData={DeleteProduct}
                    handlePagination={handlePagination}
                // multiSelectRow={onSelectedRowsChange}
                // clearSelectedRows={toggleCleared}
                />
            </div>

            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg shadow-lg p-4 w-96 relative">
                        <button
                            onClick={handleCloseModal}
                            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 font-bold"
                        >
                            ✕
                        </button>
                        <img src={modalImage} alt="OTP Verified" className="w-full h-auto rounded" />
                    </div>
                </div>
            )}
        </div>
    );
};
export default FetchAWBNumbersBYfranchise
